import {
  initReactI18next,
  useTranslation as translateFunction,
  UseTranslationResponse,
} from 'react-i18next';
import i18n, { KeyPrefix } from 'i18next';

import component from './component.json';
import layout from './layout.json';
import page from './page.json';

declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false;
  }
}

export const useTranslation = (
  keyPrefix: KeyPrefix<string>
): UseTranslationResponse<'translation', undefined> => {
  return translateFunction('', { keyPrefix });
};

const resources = {
  en: {
    translation: {
      ...layout,
      ...page,
      ...component,
    },
  },
};

/* i18next default export; .use().init() is the documented setup API. */
// eslint-disable-next-line import/no-named-as-default-member -- i18n.use(initReactI18next)
i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  interpolation: {
    escapeValue: false,
  },
  returnNull: false,
});

export default i18n;
